/**
 * Where to land when the caregiver switches accounts in the elder switcher.
 *
 * We keep them on the same tab where that's unambiguous. Voice / Activity /
 * Settings are addressed by `/accounts/:aid/<section>` alone, so they carry
 * straight across. The Calendar tab is `/accounts/:aid/calendars/:cid/events`
 * — the `:cid` belongs to the *old* account, so it can't carry over; we fall
 * back to Voice, the app's default landing (see RootRedirect), rather than
 * point the new account at a calendar it doesn't own.
 */

const CARRYOVER_SECTIONS = new Set(['voice', 'activity', 'settings']);

const DEFAULT_SECTION = 'voice';

export function accountSwitchTarget(
  pathname: string,
  fromAid: string | undefined,
  toAid: string,
): string {
  const prefix = fromAid ? `/accounts/${fromAid}/` : '';
  const section =
    prefix && pathname.startsWith(prefix)
      ? (pathname.slice(prefix.length).split('/')[0] ?? '')
      : '';
  const target = CARRYOVER_SECTIONS.has(section) ? section : DEFAULT_SECTION;
  return `/accounts/${toAid}/${target}`;
}
